import { Component} from '@angular/core';
import { GeneralTeacherComponent } from '../../General/gt.component';
import { ActivatedRoute } from '@angular/router';
import { NumberCardsService } from '../number-cards.service';
import {TopicService } from '../topic.service';
import { Location } from '@angular/common';
import { TSuperExerciseComponent } from '../t-super-exercise/t-super-exercise.component';

@Component({
  selector: 'app-t-position-card',
  templateUrl: './t-position-card.component.html',
  styleUrls: ['./t-position-card.component.css']
})
export class TPositionCardComponent extends TSuperExerciseComponent {


  //typespecifics
 
  requestedNumber: number = 0;
  
 
  private count: number[] = [];
  showImmediateHelp: boolean = false;
  showComputation: boolean = true;

  constructor(protected activatedRoute: ActivatedRoute, protected numberCardsService: NumberCardsService, protected topicService: TopicService, protected _location: Location) {
    super(activatedRoute, numberCardsService, topicService);
    this.type = "positionRepresentation";
    this.title = this.get("positionCardName");
  }

   /** sets information based on configuration */
  setInformationWithConfiguration(){
    super.setInformationWithConfiguration(); 
    this.requestedNumber = this.configuration.typespecifics.requestedNumber;
    this.showImmediateHelp = this.configuration.typespecifics.showImmediateHelp;
    this.showComputation = this.configuration.typespecifics.showComputation;
    this.onChangeRepr();
  }

  /** resets all the variables */
  reset(){
    super.reset();
    this.title = this.get("positionCardName");
    this.requestedNumber = 0;
    this.cards = [];
    this.count = [];
    this.showImmediateHelp = false;
    this.showComputation = true;
  }

  

  /** generate the exercise definition */
  generateDefinition(): any {
    let definition = super.generateDefinition();
    definition.image = "./assets/images/dataRepresentationPosition.png";
    definition.key="dataRepresentation%positionRepresentation%";
    if(this.examId > -1) {
      definition.key = definition.key.concat("exam%", this.examId.toString(), "%");
    }
    definition.key = definition.key.concat(this.representation, "%", this.representationSpec.toString().replace(new RegExp(" ", 'g'), ""), "%", this.requestedNumber.toString())
    definition.typespecifics.requestedNumber = this.requestedNumber;
    definition.typespecifics.showImmediateHelp = this.showImmediateHelp;
    definition.typespecifics.showComputation = this.showComputation;
    definition.level=(this.showImmediateHelp?1:2);
    return definition;
  }

   /** computes and sets the cards */
   onChangeRepr() {
    super.onChangeRepr();
    this.onChangeRequestedNumber();
  }

   /** sets the counts correctly  */
   onChangeRequestedNumber() {
     this.requestedNumber = Math.floor(this.requestedNumber);
    if (this.representationDefined()) {
      let solution = this.numberCardsService.getSolution(this.requestedNumber, this.cards);
      let index = 0;
      for (let card of this.cards) {
        this.count[card] = solution[index];
        index++;
      }
    }
  }

  /** computes the value based on Cards */
  onChangeCount(card:number){
    this.requestedNumber = this.numberCardsService.getValue(this.count);
    let solution = this.numberCardsService.getSolution(this.requestedNumber, this.cards);
    let index = 0;
    for(let card of this.cards){
      this.count[card] = solution[index];
      index++;
    }
  }

  /** generate the exercise automatically */
  generate() {
    super.generate();
    this.requestedNumber = Math.floor(Math.random() * this.maxNumber());
    this.title = this.get("positionCardName");
    this.onChangeRepr();
    this.onChangeRequestedNumber();
  }

}
